module.exports = __webpack_public_path__ + "static/media/Station4.61f8279a.png";